import { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import { Tag } from '../Tag/tag.component';
import { OrderProductionStatusEnum, OrderStatusEnum } from '../../Services/api/orders/orders.interface';
import { normalizeOrderStatusColors, normalizeOrderStatusTitle } from '../../utils/normalizeOrderStatus';

interface IOrderStatusCell {
  status: OrderStatusEnum;
  productionStatus: OrderProductionStatusEnum;
  errorMessage?: string;
}

export const OrderStatusCell: FC<IOrderStatusCell> = ({ 
  status, 
  productionStatus, 
  errorMessage 
}) => {
  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '10px',
      py: 1,
      px: 1
    }}>
      {[OrderStatusEnum.OPEN, OrderStatusEnum.PROCESSING].includes(status) ? (
        <Tag 
          title='Processando' 
          boxStyle={{ 
            backgroundColor: 'rgba(33, 150, 243, 0.7)', 
            width: '100%', 
            padding: '12px', 
            whiteSpace: 'nowrap', 
            boxSizing: 'border-box' 
          }} 
          titleStyle={{ 
            color: '#FFFFFF', 
            fontSize: '15px', 
            width: '100%', 
            textAlign: 'center', 
            whiteSpace: 'nowrap', 
            boxSizing: 'border-box' 
          }} 
        />
      ) : (
        <>
          {productionStatus === OrderProductionStatusEnum.PRODUCTION && status !== OrderStatusEnum.DEAD && (
            <Tag 
              title='Em Produção' 
              boxStyle={{ 
                backgroundColor: 'rgba(223, 148, 27, 0.7)', 
                width: '100%', 
                padding: '12px', 
                whiteSpace: 'nowrap', 
                boxSizing: 'border-box' 
              }} 
              titleStyle={{ 
                color: '#FFFFFF', 
                fontSize: '15px', 
                width: '100%', 
                textAlign: 'center', 
                whiteSpace: 'nowrap', 
                boxSizing: 'border-box' 
              }} 
            />
          )}

          {[OrderProductionStatusEnum.STAND_BY].includes(productionStatus) && status !== OrderStatusEnum.DEAD && (
            <Tag 
              title='Aguardando produção' 
              boxStyle={{ 
                backgroundColor: 'rgba(110, 197, 5, 0.73)', 
                width: '100%', 
                padding: '12px', 
                whiteSpace: 'nowrap', 
                boxSizing: 'border-box' 
              }} 
              titleStyle={{ 
                color: '#FFFFFF', 
                fontSize: '15px', 
                width: '100%', 
                textAlign: 'center', 
                whiteSpace: 'nowrap', 
                boxSizing: 'border-box' 
              }} 
            />
          )}

          {[OrderProductionStatusEnum.HALF_FINISHED].includes(productionStatus) && status !== OrderStatusEnum.DEAD && (
            <Tag 
              title='Parcialmente produzido' 
              boxStyle={{ 
                backgroundColor: 'rgba(18, 120, 237, 0.7)', 
                width: '100%', 
                padding: '12px', 
                whiteSpace: 'nowrap', 
                boxSizing: 'border-box' 
              }} 
              titleStyle={{ 
                color: '#FFFFFF', 
                fontSize: '15px', 
                width: '100%', 
                textAlign: 'center', 
                whiteSpace: 'nowrap', 
                boxSizing: 'border-box' 
              }} 
            />
          )}

          {status === OrderStatusEnum.DEAD && (
            <Tooltip 
              title={errorMessage || 'Motivo não informado'}
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: 'red',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    '& .MuiTooltip-arrow': {
                      color: 'red'
                    }
                  }
                }
              }}
            >
              <Box sx={{ 
                width: '100%', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Tag 
                  title='Pedido com Problema' 
                  boxStyle={{ 
                    backgroundColor: 'red', 
                    color: 'white', 
                    fontSize: '15px', 
                    padding: '12px', 
                    cursor: 'pointer',
                    textAlign: 'center',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    boxSizing: 'border-box'
                  }} 
                  titleStyle={{ 
                    color: 'white', 
                    fontSize: '15px', 
                    textAlign: 'center', 
                    cursor: 'pointer',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    boxSizing: 'border-box'
                  }} 
                />
              </Box>
            </Tooltip>
          )}

          {status === OrderStatusEnum.INVOICE_PROBLEM && (
            <Tooltip 
              title={errorMessage || 'Motivo não informado'}
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: 'red',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    '& .MuiTooltip-arrow': {
                      color: 'red'
                    }
                  }
                }
              }}
            >
              <Box sx={{ 
                width: '100%', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Tag 
                  title='Problema no faturamento' 
                  boxStyle={{ 
                    backgroundColor: 'red', 
                    color: 'white', 
                    fontSize: '15px', 
                    padding: '10px', 
                    cursor: 'pointer',
                    textAlign: 'center',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    boxSizing: 'border-box'
                  }} 
                  titleStyle={{ 
                    color: 'white', 
                    fontSize: '15px', 
                    textAlign: 'center', 
                    cursor: 'pointer',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    boxSizing: 'border-box'
                  }} 
                />
              </Box>
            </Tooltip>
          )}
            
          {![OrderStatusEnum.DEAD].includes(status) && 
           status !== OrderStatusEnum.INVOICE_PROBLEM && 
           productionStatus === OrderProductionStatusEnum.FINISHED && (
            <Tag 
              title={normalizeOrderStatusTitle(status as OrderStatusEnum)} 
              boxStyle={{ 
                backgroundColor: normalizeOrderStatusColors(status as OrderStatusEnum)?.bgColor, 
                width: '100%', 
                padding: '12px',
                whiteSpace: 'nowrap',
                boxSizing: 'border-box'
              }} 
              titleStyle={{ 
                color: normalizeOrderStatusColors(status as OrderStatusEnum)?.textColor, 
                fontSize: '15px', 
                width: '100%', 
                textAlign: 'center',
                whiteSpace: 'nowrap',
                boxSizing: 'border-box'
              }} 
            />
          )}
        </>
      )}
    </Box>
  );
};
